import type { components } from "@qorakul/shared/api";

export type DayOfWeek = components["schemas"]["DayOfWeek"];
export type TimetableDetails = components["schemas"]["TimetableDetails"];
export type TimetableSlotInput = components["schemas"]["TimetableSlotInput"];
export type LessonGenerationResult = components["schemas"]["LessonGenerationResult"];

export const timetableKeys = {
  all: (classId: string) => ["academic", "timetable", classId] as const,
  at: (classId: string, date: string | undefined) => ["academic", "timetable", classId, date ?? "today"] as const,
};

/** Monday first, as the school week reads. */
export const weekDays: DayOfWeek[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const maxPeriod = 10;
export const defaultPeriodCount = 6;

/** A period row of the editor: the same start and end time on every weekday. Times are "HH:mm". */
export interface PeriodTimes {
  startTime: string;
  endTime: string;
}

const firstLessonMinutes = 8 * 60;
const lessonMinutes = 45;
const breakMinutes = 10;

function toTime(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

/** Sensible default: first lesson at 08:00, 45-minute lessons with 10-minute breaks. */
export function defaultTimes(period: number): PeriodTimes {
  const start = firstLessonMinutes + (period - 1) * (lessonMinutes + breakMinutes);
  return { startTime: toTime(start), endTime: toTime(start + lessonMinutes) };
}

/** "08:00:00" from the API to "08:00" for the editor. */
export function shortTime(value: string): string {
  return value.slice(0, 5);
}

/** Editor cell key. */
export function cellKey(weekday: DayOfWeek, period: number): string {
  return `${weekday}-${period}`;
}
